import React from 'react';
import DigitalAssetsPage from '@t7x000/apex-web/lib/components/DigitalAssets/DigitalAssetsPageContainer';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import './DigitalAssets.css';
import { useTranslation } from 'react-i18next';

const classes = getBEMClasses('digital-assets-page');

const DigitalAssets = () => {
  const { t } = useTranslation();

  return (
    <div className={classes()}>
      <div className={classes('content')}>
        <div className={classes('main')}>
          <header className={classes('hero')}>
            <h1 className={classes('title')}>{t('Digital Assets')}</h1>
            <p className={classes('lede')}>{t('Browse live token offerings, amounts, and full project profiles.')}</p>
          </header>
          <div className={classes('da-root')}>
            <DigitalAssetsPage />
          </div>
        </div>
      </div>
      <div className={classes('footer')}>
        <PageFooterLayout />
      </div>
    </div>
  );
};

export default DigitalAssets;
